import axios from "axios";
import { useState, useEffect } from "react";
import { Form, Row, Col, Button, Alert } from "react-bootstrap";
import { Outlet, useNavigate } from "react-router-dom";

import {
  ACCESS_LEVELS,
  AUTH_ROLES,
  PERMISSION_AREAS,
} from "api/common/types/auth.types";
import { useIsErtTeamMemberQuery } from "api/memberPortal/virtualTeam/virtualTeam.api";
import { useLoading } from "components/UI/LoadingSpinner/UseLoading";
import UnauthorizedView from "components/UI/UnauthorizedView";
import { useAuth } from "hooks/useAuth";
import { checkPermissions } from "utils/permissions";

export default function CheckPermEARManager() {
  const { permissions } = useAuth();
  const { showLoadingSpinner, hideLoadingSpinner } = useLoading();

  const { data: isErtTeamMember, isLoading } = useIsErtTeamMemberQuery();

  const hasEarReviewReadPermissions = checkPermissions({
    permissions,
    area: PERMISSION_AREAS.EAR_REVIEWS,
    access: ACCESS_LEVELS.READ,
  });

  const hasPermissions =
    permissions.role_type === AUTH_ROLES.NIAP ||
    permissions.role_type === AUTH_ROLES.LAB ||
    (permissions.role_type === AUTH_ROLES.VALIDATOR &&
      hasEarReviewReadPermissions) ||
    (permissions.role_type === AUTH_ROLES.SME && isErtTeamMember);

  useEffect(() => {
    if (isLoading) {
      showLoadingSpinner("Loading EAR...");
    } else {
      hideLoadingSpinner();
    }
  }, [isLoading]);

  if (isLoading) return null;

  return hasPermissions ? <EARManager /> : <UnauthorizedView />;
}

function EARManager() {
  const [jumpEar, setJumpEar] = useState({});
  const [alert, setAlert] = useState({});
  const navigate = useNavigate();
  const { authToken } = useAuth();

  const handleChange = (e) => {
    setJumpEar({ ...jumpEar, [e.target.name]: e.target.value });
  };

  const jump = (e) => {
    e.preventDefault();
    axios
      .get(`${import.meta.env.VITE_DJANGO_ENDPOINT}ear/${jumpEar.earid}`, {
        withCredentials: true,
        headers: { Authorization: `Token ${authToken}` },
      })
      .then((response) => {
        setAlert({});
        navigate(`/community/ear-reviews/details/${response.data.earid}`);
      })
      .catch((error) => {
        console.log(error.response.data.detail);
        setAlert({
          message: `Error completing Request: ${error.response.data.detail}`,
          variant: "warning",
        });
      });
  };

  return (
    <>
      {alert?.message && (
        <Alert
          variant={alert?.variant}
          dismissible
          onClose={() => setAlert({})}
        >
          {alert?.message}
        </Alert>
      )}
      <Form onSubmit={jump}>
        <Row className="justify-content-end mb-2">
          <Col xs={12} md={3}>
            <Form.Group controlId="jumpbox">
              <Form.Label className="visually-hidden">Jump to EAR</Form.Label>
              <Form.Control
                name="earid"
                onChange={handleChange}
                placeholder="Jump to EAR"
              />
            </Form.Group>
          </Col>
          <Col xs={12} md="auto">
            <Button type="submit" className="w-100 w-md-auto mt-2 mt-md-0">
              Jump
            </Button>
          </Col>
        </Row>
      </Form>

      <Outlet />
    </>
  );
}
